import { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import { OSId } from '@ps/platform-message-framework/common/OSId';
import { select } from '@ps/web-core-store';
import { integrationTesting } from '@ps/web-core-utils';
import type { WebsiteConfig } from '@ps/web-martech-cms-types';
import { useNavigate } from '@ps/web-shared-components';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Vertical } from '../components/CMSHeader/components/BrandLinks/BrandLinks';

const brandVerticalMapping: Partial<Record<BrandTypes, string>> = {
  [BrandTypes.POKER_STARS]: Vertical.Poker,
  [BrandTypes.STARS_CASINO]: Vertical.Casino,
  [BrandTypes.BET_STARS]: Vertical.Sports
};

const usePostDownloadNavigation = () => {
  const pathname = useSelector(select.location.getPathname);
  const brandId = useSelector(select.cms.getBrandId);
  const osId = useSelector(select.device.getOS);
  const embedded = useSelector(select.device.isEmbedded);
  const cmsContent = useSelector(select.cms.getContent);
  const website = useSelector(select.cms.getWebsite);
  const refs = website?.website_config;
  const websiteConfig = !!refs?.length && (cmsContent[refs[0].uid] as WebsiteConfig);
  const isPostDownloadRedirectEnabled = websiteConfig
    ? websiteConfig.enable_post_download_redirect
    : undefined;
  const navigate = useNavigate();

  const navigateToPostDownloadPage = useCallback(
    (url: string | undefined | null) => {
      if (!url) return;

      const isClientDownloadLink = url.includes('/client/download/');
      const isDownloadPage = pathname.includes('/download/');
      const vertical = brandVerticalMapping[brandId] || Vertical.Poker;
      const shouldNavigateToPostDownloadPage =
        !embedded &&
        !integrationTesting &&
        !isDownloadPage &&
        isClientDownloadLink &&
        isPostDownloadRedirectEnabled &&
        (osId === OSId.MAC || osId === OSId.WINDOWS);

      if (shouldNavigateToPostDownloadPage) {
        navigate(`/${vertical}/download/${osId === OSId.MAC ? 'mac/' : ''}?ctd=1`);
      }
    },
    [pathname, brandId, embedded, isPostDownloadRedirectEnabled, osId, navigate]
  );

  return navigateToPostDownloadPage;
};

export default usePostDownloadNavigation;
